module.exports = __webpack_public_path__ + "static/media/logos.4e76cf6c.png";